/**
 * @module constants
 */
/**
 * Maximum exceptable precision
 * @since 	1.1.0
 * @const {number}
 */
export const MAX_PRECISION = 20;

/**
 * @enum {string}
 * @since 2.0.0
 */
export const COUNTRY_CODE = {
  SG: 'SG',
  ID: 'ID',
  MY: 'MY',
  PH: 'PH',
  TW: 'TW',
  TH: 'TH',
  VN: 'VN',
  IR: 'IR',
  HK: 'HK',
  BR: 'BR',
  CN: 'CN',
  MX: 'MX',
  CO: 'CO',
  CL: 'CL',
  AR: 'AR',
  PL: 'PL',
  ES: 'ES',
  FR: 'FR',
  IN: 'IN',
  US: 'US',
  KR: 'KR',
  JP: 'JP',
  KH: 'KH',
  MM: 'MM',
  LA: 'LA',
} as const;

/**
 * @enum {string}
 * @since 2.0.0
 */
export const CURRENCY_ID = {
  SGD: 'SGD',
  IDR: 'IDR',
  MYR: 'MYR',
  PHP: 'PHP',
  TWD: 'TWD',
  THB: 'THB',
  VND: 'VND',
  IRR: 'IRR',
  HKD: 'HKD',
  BRL: 'BRL',
  CNY: 'CNY',
  MXN: 'MXN',
  COP: 'COP',
  CLP: 'CLP',
  ARS: 'ARS',
  PLN: 'PLN',
  EUR: 'EUR',
  INR: 'INR',
  USD: 'USD',
  KRW: 'KRW',
  JPY: 'JPY',
  KHR: 'KHR',
  MMK: 'MMK',
  LAK: 'LAK',
} as const;

export const LANGUAGE = {
  /** English */
  en: 'en',
  /** Bahasa Indonesia */
  id: 'id',
  /** Bahasa Melayu */
  ms: 'ms',
  /** Burmese */
  my: 'my',
  /** Simplified Chinese */
  'zh-Hans': 'zh-Hans',
  /** Traditional Chinese */
  'zh-Hant': 'zh-Hant',
  /** Thai */
  th: 'th',
  /** Vietnamese */
  vi: 'vi',
  /** Brazilian Portugese */
  'pt-BR': 'pt-BR',
  /** Mexican Spanish */
  'es-MX': 'es-MX',
  /** Colombian Spanish */
  'es-CO': 'es-CO',
  /** Chilean Spanish */
  'es-CL': 'es-CL',
  /** Argentinian Spanish */
  'es-AR': 'es-AR',
  /** Polish */
  pl: 'pl',
  /** Spanish */
  'es-ES': 'es-ES',
  /** French */
  fr: 'fr',
  /** Hindi */
  hi: 'hi',
  /** Filipino */
  fil: 'fil',
  /** Korean */
  ko: 'ko',
  /** Japanese */
  ja: 'ja',
  /** Khmer */
  km: 'km',
} as const;
